import { render, staticRenderFns } from "./default.vue?vue&type=template&id=697457b6&comments=true"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/home/korzinka/www/front/components/App/Header.vue').default,AppRegion: require('/home/korzinka/www/front/components/App/Region.vue').default,AppFooter: require('/home/korzinka/www/front/components/App/Footer.vue').default})
